import { useState } from "react";
import { I } from "./icons.jsx";
import { PLATFORMS } from "../data/mock.js";

const STATUSES = [
  { k: "all",      l: "All",      n: 14 },
  { k: "live",     l: "Live",     n: 9  },
  { k: "upcoming", l: "Upcoming", n: 3  },
  { k: "draft",    l: "Draft",    n: 2  },
  { k: "past",     l: "Past" },
];

export default function Filters({ status, onStatus, view, onView, plats, togglePlat, q, onQ }) {
  return (
    <div className="filters">
      <label className="search">
        <I.search/>
        <input placeholder="Search events, venues, artists, ticket refs…" value={q} onChange={(e)=>onQ(e.target.value)} />
        <span className="kbd">⌘K</span>
      </label>

      <div className="seg" role="tablist">
        {STATUSES.map(s => (
          <button key={s.k} className={status===s.k?"on":""} onClick={()=>onStatus(s.k)}>
            {s.l} {s.n!=null && <span style={{opacity:.5,marginLeft:4,fontFamily:"var(--mono)"}}>{s.n}</span>}
          </button>
        ))}
      </div>

      <div className="chips">
        {Object.entries(PLATFORMS).map(([key, p]) => (
          <button key={key} className={`chip${plats[key]?" on":""}`} onClick={()=>togglePlat(key)}>
            <span className="swatch" style={{background:p.color}}/>
            {p.name}
            <span className="ct">{p.code}</span>
          </button>
        ))}
      </div>

      <div className="filter-spacer"/>
      <div className="seg">
        {[
          {k:"table",icon:"table"},
          {k:"grid", icon:"grid"},
          {k:"cal",  icon:"cal2"},
          {k:"map",  icon:"map"},
        ].map(v => {
          const Icon = I[v.icon];
          return (
            <button key={v.k} className={view===v.k?"on":""} onClick={()=>onView(v.k)} title={v.k}>
              <Icon width="13" height="13" strokeWidth={1.6}/>
            </button>
          );
        })}
      </div>
    </div>
  );
}
